import { Component, OnDestroy, OnInit } from '@angular/core';
import { EventDetailsController } from '../event-details.controller';
import { PrintingProvider } from '@internal-providers/printing.provider';
import { PrintingService } from '@shared-services/print.service';
import { Action, NavigationType } from '@shared-libs/enums';
import { EventComponent } from '@internal-components/event-components/event-component/event.component';
import { CalendarController } from '@internal-pages/calendar-page/calendar.controller';
import { isEmpty } from 'lodash';
import { translate } from '@shared-libs/helpers';
import { MessageService } from '@shared-services/message.service';

@Component({
	selector: 'event-details-desktop-component',
	templateUrl: 'event-details.desktop.component.html',
	styleUrls: ['./event-details.desktop.component.scss'],
})
export class EventDetailsDesktopComponent implements OnInit, OnDestroy {
	constructor(
		public readonly controller: EventDetailsController,

		private readonly printingProvider: PrintingProvider,
		private readonly printingService: PrintingService,
		private readonly calendarController: CalendarController,
		private readonly messageService: MessageService
	) {}

	public async ngOnInit(): Promise<void> {
		this.controller.onInit();
	}
	public ngOnDestroy(): void {
		this.controller.onDestroy();
	}

	public async print(): Promise<void> {
		const html = await this.printingProvider.getHTMLConfirmationForWalkInEvent(
			this.controller.event.id,
			this.controller.calendarEvent.id
		);
		await this.printingService.print(html);
	}

	public async exportNonAnonymousAttendances(): Promise<void> {
		if (this.controller.event.Reservations.filter((reservation) => reservation.isActive).length < 1) {
			return;
		}
		await this.controller.attendanceProvider.getNonAnonymousAttendancesOfEventDay(
			this.controller.event.id,
			this.controller.calendarEvent.id
		);
	}

	public async updateEvent(): Promise<void> {
		void this.controller.navigationService
			.navigateTo(NavigationType.modal, EventComponent, {
				event: { ...this.controller.event, CalendarEvent: this.controller.calendarEvent },
				action: Action.UPDATE,
			})
			.then(() => {
				this.calendarController.getDisplayCalendarEvents();
			})
			.catch();
	}

	public mailAllClients() {
		if (this.controller.event.Reservations.length < 1) {
			return;
		}
		let addresses = this.controller.event.Reservations.filter(
			(reservation) => reservation.isActive && reservation.Client && !isEmpty(reservation.Client.email)
		)
			.map((reservation) => reservation.Client.email)
			.toString();
		if (addresses) {
			navigator.clipboard.writeText(addresses);
			this.messageService.showSavedMessage(translate('EVENT.ADDRESSES_COPIED'), false);
			setTimeout(() => {
				location.href = 'mailto:?bcc=' + addresses;
			}, 1000);
		} else {
			this.messageService.showSavedMessage(translate('EVENT.NO_ADDRESSES_COPIED'));
		}
	}
}
